
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import Config from '@/utils/config';
import DB from '@/utils/api/DB';
@Component
export default class TripCheck extends Vue {

    UID = DB.Get('user.info').id;

    @Prop({ default: null })
    Row!: any;


    Config = Config;

    get Traffic() {
        if (this.Row) {
            if (this.Row.traffic == 0)
                return '长途汽车';
            if (this.Row.traffic == 1)
                return '公务用车';
            if (this.Row.traffic == 2)
                return '火车';
            if (this.Row.traffic == 3)
                return '飞机';
            if (this.Row.traffic == 4)
                return '其他';
        }
        return '其他';
    }

}
